import {HttpClient} from "../../service/httpClient/HttpClient";

export class MawakibService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getMawakibList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-periods`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    getMawakibDetailInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-periods/${id}`
            ).then(resolve).catch(reject)
        })
    }

    getMawakibRegisteredList(id, page, size, name, status) {
        return new Promise((resolve, reject) =>
            this.httpClient.get(
                `mawakib-registration-periods/${id}/mawakib-registrations`,
                {
                    page,
                    size,
                    name,
                    status: status === "ALL" ? "" : status,
                }
            ).then(resolve).catch(reject)
        )
    }

    getMawakibRegisteredDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registrations/${id}`,
            ).then(resolve).catch(reject)
        })
    }

    getMawakibCSVReports(mawakibPeriodId, locationId, reportStatus) {
        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `mawakib-registration-periods/${mawakibPeriodId}/mawakib-registrations/reports/XLSX`,
                {},
                {
                    locationId: locationId ? locationId : null,
                    status: reportStatus ? reportStatus : null,
                }
            ).then(resolve).catch(reject)
        })
    }

    updateRegisterState(id, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `mawakib-registrations/${id}`,
                {},
                {
                    status
                }
            ).then(resolve).catch(reject)
        })
    }

    getMawakibLocationSelection(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-locations/selections`
            ).then(resolve).catch(reject)
        })
    }

    getMawakibServantRegisters(id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-periods/${id}/mawkib-servant-registrations`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getMawakibServantRegisterDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-servant-registration/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    getMawakibServiceList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-services`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getMawakibServiceDetails(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-services/${id}`,
            ).then(resolve).catch(reject)
        })
    }

    getMawakibRegistrationLicense(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-licenses`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getMawKibLicenseDetails(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-licenses/${id}`
            ).then(resolve).catch(reject)
        })
    }

    getMawkibRegistrationLocation(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-locations`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getMawkibLocationDetails(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `mawakib-registration-locations/${id}`
            ).then(resolve).catch(reject)
        })

    }
}